module.exports = __webpack_public_path__ + "img/folder-fill.e01451da.svg";